<template>
  <div class="communicationTable-component">
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="10000000"
      hide-default-footer
      disable-sort
      :hide-default-header="isMobile"
      :no-data-text="$t('Communications.table.noData')"
      @click:row="rowClicked"
    >
      <template v-slot:item.titolo="{ item }">
        <div v-if="!isMobile">
          <div v-if="isReadNoOK(item)" class="red-dot"></div>
          <div :class="[isReadNoOK(item) ? 'title-div readNoOk' : '']">
            <span
              :class="[
                isReadNoOK(item) ? 'title-span underlined' : 'title-span',
              ]"
              >{{ !item.read ? item.titolo : item.titolo }}</span
            >
          </div>
        </div>
        <div v-else class="mobile-div">
          <div v-if="isReadNoOK(item)" class="red-dot"></div>
          <div
            :class="[
              isReadNoOK(item)
                ? 'first-div-wrapper readNoOk'
                : 'first-div-wrapper',
            ]"
          >
            <div class="first-div">
              <span>{{ item.titolo }}</span
              ><span class="right-span">{{
                formatDate(item.dataCaricamento)
              }}</span>
            </div>
            <div>
              <span v-html="item.divisioni"></span><br />
              <span v-if="item.read">{{
                $t("Communications.readCommunications")
              }}</span
              ><span v-else>{{
                $t("Communications.notReadCommunications")
              }}</span
              ><br />
              <span>{{ $t("Communications.table.acceptDate") }}:</span
              ><span>{{ formatDate(item.dataAccettazione) }}</span>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:item.dataCaricamento="{ item }">
        <span :class="[isReadNoOK(item) ? 'readNoOk' : '']">
          {{ formatDate(item.dataCaricamento) }}
        </span>
      </template>
      <template v-slot:item.dataAccettazione="{ item }">
        <span :class="[isReadNoOK(item) ? 'readNoOk' : '']">
          {{ formatDate(item.dataAccettazione) }}
        </span>
      </template>
      <template v-slot:item.divisioni="{ item }">
        <span
          v-html="item.divisioni"
          :class="[isReadNoOK(item) ? 'readNoOk' : '']"
        >
        </span>
      </template>
      <template v-slot:item.obbligatoria="{ item }">
        <span>
          {{
            item.obbligatoria
              ? $t("Communications.table.mandatory")
              : $t("Communications.table.notMandatory")
          }}
        </span>
      </template>
      <template v-slot:item.read="{ item }">
        <span :class="[isReadNoOK(item) ? 'readNoOk' : '']">{{
          item.read
            ? $t("Communications.table.readOk")
            : $t("Communications.table.readNoOk")
        }}</span>
      </template>
    </v-data-table>
  </div>
</template>
<style>
.communicationTable-component .title-span {
  /* text-decoration: underline; */
  cursor: pointer;
}

.communicationTable-component .title-span.underlined {
  text-decoration: underline;
  cursor: pointer;
}

.communicationTable-component .v-data-table__wrapper {
  height: auto;
}

.communicationTable-component table {
  border-top: 2px solid #707070;
  border-right: 2px solid #707070;
  border-left: 2px solid #707070;
}
.communicationTable-component table tbody td:not(:last-child),
.communicationTable-component table th:not(:last-child) {
  border-right: 2px solid #707070;
}

.communicationTable-component table tbody td {
  border-top: 2px solid #707070;
  border-bottom: 2px solid #707070;
}

.communicationTable-component tbody tr:nth-of-type(odd) {
  background-color: #c8cacb;
}

.communicationTable-component tbody th span,
.v-data-table th,
.theme--light.v-data-table thead tr th {
  font: normal normal bold 20px/24px Lato;
  color: #707070;
  /* font-size: 20px !important; */
}

.communicationTable-component .v-data-table td {
  font: normal normal normal 20px/24px Lato;
  color: #707070;
  /* font-size: 20px !important; */
}

.communicationTable-component .readNoOk {
  font: normal normal 900 20px/24px Lato;
  color: #707070;
}

.communicationTable-component .title-div.readNoOk {
  margin-left: 36px;
}

.communicationTable-component .red-dot {
  border: 1px solid red;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  background-color: red;
  position: absolute;
}

.communicationTable-component tr {
  cursor: pointer;
}

@media (max-width: 600px) {
  .communicationTable-component .v-data-table__mobile-row__header {
    display: none;
  }

  .communicationTable-component .v-data-table td {
    height: auto;
  }

  .communicationTable-component .v-data-table__mobile-row__cell {
    text-align: left;
  }

  .communicationTable-component .v-data-table__mobile-row__cell {
    width: 100%;
  }

  .communicationTable-component .right-span {
    float: right;
  }

  .communicationTable-component .first-div {
    margin-bottom: 10px;
  }

  .communicationTable-component tbody th span,
  .v-data-table th,
  .theme--light.v-data-table thead tr th {
    font: normal normal bold 14px/20px Lato;
    color: #707070;
  }

  .communicationTable-component .v-data-table td {
    font: normal normal normal 14px/20px Lato;
    color: #707070;
    /* font-size: 20px !important; */
  }

  .communicationTable-component span {
    margin-top: 2px;
    margin-bottom: 2px;
  }

  .communicationTable-component .red-dot {
    border: 1px solid red;
    height: 20px;
    width: 22px;
    border-radius: 20px;
    background-color: red;
    position: unset;
    margin-right: 10px;
    margin-top: 2px;
  }

  .communicationTable-component .first-div-wrapper {
    width: 100%;
  }

  .communicationTable-component .mobile-div {
    display: flex;
    margin-top: 6px;
    margin-bottom: 6px;
  }

  .communicationTable-component .readNoOk {
    font: normal normal bold 14px/20px Lato;
    color: #707070;
  }

  .communicationTable-component .v-data-table__wrapper {
    overflow-x: unset !important;
    overflow-y: unset !important;
  }

  .communicationTable-component .v-data-table__mobile-row {
    width: 100%;
  }

  .communicationTable-component table {
    border-top: unset;
  }
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import router from "@/router/index.js";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";
import moment from "moment";

export default {
  props: {
    items: null,
    fromHistory: true,
    isOwnCommunications: false,
  },
  data() {
    return {
      isMobile: false,
      headers: [
        { text: Trans.i18n.t("Communications.table.name"), value: "titolo" },
        {
          text: Trans.i18n.t("Communications.table.division"),
          value: "divisioni",
        },
        {
          text: Trans.i18n.t("Communications.table.uploadDate"),
          value: "dataCaricamento",
        },
        {
          text: Trans.i18n.t("Communications.table.accept"),
          value: "obbligatoria",
        },
      ],
    };
  },

  created() {
    window.addEventListener("resize", this.myEventHandler);
    // console.log("from", this.fromHistory);
    this.setIsMobile();
    if (!this.isMobile) {
      if (!this.fromHistory) {
        this.headers = [
          { text: Trans.i18n.t("Communications.table.name"), value: "titolo" },
          {
            text: Trans.i18n.t("Communications.table.division"),
            value: "divisioni",
          },
          {
            text: Trans.i18n.t("Communications.table.uploadDate"),
            value: "dataCaricamento",
          },
          {
            text: Trans.i18n.t("Communications.table.read"),
            value: "read",
          },
          {
            text: Trans.i18n.t("Communications.table.acceptDate"),
            value: "dataAccettazione",
          },
        ];
      } else {
        this.headers = [
          { text: Trans.i18n.t("Communications.table.name"), value: "titolo" },
          {
            text: Trans.i18n.t("Communications.table.division"),
            value: "divisioni",
          },
          {
            text: Trans.i18n.t("Communications.table.uploadDate"),
            value: "dataCaricamento",
          },
          {
            text: Trans.i18n.t("Communications.table.accept"),
            value: "obbligatoria",
          },
        ];
      }
    } else {
      this.headers = [
        { text: Trans.i18n.t("Communications.table.name"), value: "titolo" },
      ];
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    rowClicked(item) {
      this.previewCommunication(item);
    },
    isReadNoOK(item) {
      return !item.read && !this.fromHistory;
    },
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
    previewCommunication(item) {
      //   console.log("item selected", item);
      this.$store.commit("SET_communicationSelected", item);
      this.$store.commit(
        "SET_communicationSelectedChanged",
        !this.$store.getters.GET_communicationSelectedChanged
      );
    },
    isValidDate(datetime) {
      if (!datetime || (datetime && datetime.length < 19)) {
        return false;
      }

      var parsed = moment(datetime, moment.ISO_8601);
      //console.log("datetime", datetime, parsed.isValid());
      return parsed.format() != "Invalid date";
    },
    formatDate(datetime) {
      if (this.isValidDate(datetime)) {
        // if (!this.isMobile)
        //   return moment(datetime).format("DD/MM/YYYY HH:mm:ss");
        // else return moment(datetime).format("DD/MM/YYYY");
        return moment(datetime).format("DD/MM/YYYY");
      } else return "";
    },
  },
};
</script>